module.exports = __webpack_public_path__ + "static/media/hiit-bg.8ec287ae.png";